// KEEP IN SYNC WITH hervest_backend_v2/src/utils/constants/password.constants.ts
// ANY CHARACTER THAT IS NOT A LETTER, DIGIT OR WHITESPACE COUNTS AS SPECIAL (E.g. ! @ # $ % ^ & * ( ) _ - + =)
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s])\S{8,20}$/;

export const PASSWORD_MESSAGE =
  "Password must be 8 to 20 characters and contain at least one uppercase letter, one lowercase letter, one number and one special character (e.g. ! @ # $ % ^ & * ( ) _ - + =)";
